export const _brandName = 'name'
export const _companyName = 'companyName'
export const _mainContactName = 'mainContactName'
export const _prefixContactPhone = 'prefixContactPhone'
export const _mainContactPhone = 'mainContactPhone'
export const _description = 'description'
export const _foundedInYear = 'foundedInYear'
export const _countryOfOrigin = 'countryOfOrigin'
export const _instagramUrl = 'instagramUrl'
export const _websiteUrl = 'websiteUrl'
export const _email = 'email'
export const _sales = 'sales'
export const _categoryList = 'categoryList'
export const _genders = 'genders'
export const _goals = 'goals'

export const formConfig = {
  [_brandName]: {
    name: _brandName,
    type: 'text',
    label: 'Brand Name',
  },
  [_companyName]: {
    name: _companyName,
    type: 'text',
    label: 'Company/Corporate Name',
  },
  [_mainContactName]: {
    name: _mainContactName,
    type: 'text',
    label: 'Main Contact Name',
  },
  [_email]: {
    name: 'email',
    type: 'email',
    label: 'Vendor Main Contact Email',
  },
  [_prefixContactPhone]: {
    name: _prefixContactPhone,
    label: 'prefix',
  },
  [_mainContactPhone]: {
    name: _mainContactPhone,
    type: 'tel',
    label: 'Main Contact Phone',
    placeholder: 'phone number',
  },
  [_description]: {
    name: _description,
    type: 'text',
    label: 'Short Description of Brand',
  },
  [_categoryList]: {
    label: 'Category (choose one or more)',
    name: _categoryList,
    options: [
      { value: 'beauty', label: 'Beauty' },
      { value: 'wellness', label: 'Wellness' },
      { value: 'home', label: 'Home' },
      { value: 'accessories', label: 'Accessories' },
      { value: 'other', label: 'Other' },
      { value: 'pet', label: 'Pet' },
      { value: 'groceryAndGourmetFood', label: 'Grocery & Gourmet Food' },
      { value: 'electronics', label: 'Electronics' },
      { value: 'healthcare', label: 'Healthcare' },
      { value: 'vitaminsAndSupplements', label: 'Vitamins & Supplements' },
      { value: 'sexualWellness', label: 'Sexual Wellness' },
      { value: 'exerciseAndFitness', label: 'Exercise & Fitness' },
      { value: 'fashionAccessories', label: 'Fashion Accessories' },
      { value: 'kids', label: 'Kids' },
      { value: 'womenFashion', label: 'Women Fashion' },
      { value: 'menFashion', label: 'Men Fashion' },
      { value: 'shoes', label: 'Shoes' },
      { value: 'outdoors', label: 'Outdoors' },
      { value: 'tools', label: 'Tools' },
    ],
  },
  [_genders]: {
    label: 'Gender (choose one or more)',
    name: _genders,
    options: [
      { value: 'male', label: 'Male' },
      { value: 'female', label: 'Female' },
      { value: 'unisex', label: 'Unisex' },
    ],
  },
  [_foundedInYear]: {
    name: _foundedInYear,
    type: 'year',
    label: 'Year of Establishing',
  },
  [_countryOfOrigin]: {
    name: _countryOfOrigin,
    label: 'Country of Origin',
  },
  [_instagramUrl]: {
    name: _instagramUrl,
    type: 'text',
    label: 'Instagram URL',
  },
  [_websiteUrl]: {
    name: _websiteUrl,
    type: 'text',
    label: 'Website URL',
  },
  [_sales]: {
    name: _sales,
    options: [
      { value: 'under1mln', label: '< $1 million year' },
      { value: 'from1To5mln', label: '$1-5 million year' },
      { value: 'from5To25mln', label: '$5-25 million year' },
      { value: 'over25mln', label: '$25+ million year' },
    ],
    label: 'Sales',
  },
  [_goals]: {
    label: 'What are your goals on Flip:',
    name: _goals,
    options: [
      { value: 'brandAwareness', label: 'Brand Awareness' },
      { value: 'productLaunch', label: 'Product launch' },
      { value: 'customerAcquisition', label: 'Customer acquisitions' },
      { value: 'increaseSales', label: 'Increase sales' },
    ],
  },
}
